import { render, staticRenderFns } from "./VATReportBE.vue?vue&type=template&id=36d5aa79&scoped=true&"
import script from "./VATReportBE.vue?vue&type=script&lang=js&"
export * from "./VATReportBE.vue?vue&type=script&lang=js&"
import style0 from "./VATReportBE.vue?vue&type=style&index=0&id=36d5aa79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5aa79",
  null
  
)

export default component.exports